import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations, LANGS } from "@/i18n/translations";

const I18nContext = createContext(null);

function resolve(obj, path) {
  return path.split(".").reduce((acc, k) => (acc ? acc[k] : undefined), obj);
}

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mre_lang") || "en");

  useEffect(() => {
    localStorage.setItem("mre_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (key) => {
      const val = resolve(translations[lang], key);
      if (val !== undefined) return val;
      return resolve(translations.en, key) ?? key;
    },
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
